import React, { useEffect, useState, useContext } from "react";
import { UserDelimitation } from "../users/UserDelimitation";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { lookupsService } from "../../services/LookupsService";
import { eventService } from "../../services/EventService";
import { eventRegisterService } from "../../services/EventRegisterService";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import { APP_TYPE } from "../../config/Config";
import ScreenLoader from "../../componets/ScreenLoader";
import { InputText } from "primereact/inputtext";
import { authenticationService } from "../../services/AuthenticationService";
import { AppDB } from "../../App";
import { CandidateDBContext } from "../CandidateManagement/CandidateDBContext";
import ReportSortOrder from "../../componets/ReportSortOrder";
import { DermacationLevels } from "../../../src/constants";

export default function ReportFilter({ isPortal = false, onSubmit = () => { }, loading, reportType,showSortFilter=false, GenerateReportBtnTittle = "Generate Report", InludeVillageOnSortConfig = true}) {
	var [defaultOptions, setDefaultOptions] = useState([]);
	var [options, setOptions] = useState([]);
	var [refresh, setRefresh] = useState(false);
	var [finalEventsRegister, setFinalEventsRegister] = useState([]);
	var [provisionalEventsRegister, setProvisionalEventsRegister] = useState([]);
	var [selectedRegisterValue, setSelectedRegisterValue] = useState(null);
	var [isNationalDemarcation, setIsNationalDemarcation] = useState(true);
	var [liveFinalEventsRegister, setLiveFinalEventsRegister] = useState(null);
	var [liveProvisionalEventsRegister, setLiveProvisionalEventsRegister] = useState(null);
	var [events, setEvents] = useState(null);
	var [onOpenLoading, setOnOpenLoading] = useState(true);
	var { lookUp } = useContext(AppDB);
	const { selectedCanditate } = useContext(CandidateDBContext)


	useEffect(() => {
		setDefaultOptions(window.reportTypes[reportType.Type] ?? []);
	}, []);

	useEffect(() => {
		setOptions(window.reportTypes[reportType.Type]);
		var time = setTimeout(() => {
			if (defaultOptions.length > 0) {
				GetRegister();
			}
		}, 500);
		return () => {
			clearTimeout(time);
		};
	}, [APP_TYPE, defaultOptions]);

	useEffect(() => {
		setLookUpData(lookUp);
		setEvents(GetEvents());
		eventRegisterService.GetLiveVoterRegister({ RegisterTypeID: 2, VoterRegisterTypeID: 1 }).then((res) => {
			if (res?.success) {
				setLiveProvisionalEventsRegister(res.data);
			}
		});

		eventRegisterService.GetLiveVoterRegister({ RegisterTypeID: 2, VoterRegisterTypeID: 2 }).then((res) => {
			if (res?.success) {
				setLiveFinalEventsRegister(res.data);
			}
		});
	}, []);
	function DisableFetchReportBtn(reportInfo)
	{
		var selectedReport = reportInfo?.selectedReport;
		if(!selectedReport)
		{
			return true;
		}

		if(reportInfo?.selectedReport?.isRegistrationCentreOnlyReport && reportInfo?.delimitationLevelID !== DermacationLevels?.Level4)
		{
			return true;
		}

		return false;
	}
	async function GetEvents(ActiveOnly = true) {
		await eventService
			.getAllEvents({
				PageIndex: 1,
				PageSize: 10000,
				ActiveOnly: ActiveOnly,
				IncludeByElection: true
			})
			.then((data) => {
				setEvents(data);
			})
			.catch((err) => {
				console.log(err);
			});
	}
	function portalUserDemarcation() {


		var userDelimitations = authenticationService.getUserDelimitation();
		var obj = {
			districtId: null,
			constituencyId: null,
			pollingDivisionId: null,
			registrationCentreId: null,
			villageId: null
		};

		var isNational = [null, "", undefined].includes(selectedRegisterValue?.isNationalDelimitation)
			? true
			: selectedRegisterValue?.isNationalDelimitation

		if ("isCandidate" in (selectedCanditate??{})) {
			if (userDelimitations.length > 0 && isPortal) {
				const { districtID, constituencyID, votingDistrictID } = userDelimitations[0];

				var _userIsNational = userDelimitations[0].isNationalDelimitation
				if (isNational === _userIsNational) {
					obj.districtId = districtID;
					obj.constituencyId = constituencyID;
					obj.pollingDivisionId = votingDistrictID;
				}
			}
		}

		return obj;
	}

	async function GetRegister() {
		if (APP_TYPE == "PoliticalParty") {
			setOptions(defaultOptions.filter((e) => e.reportID != 11 && e.reportID != 20));
		}

		await eventRegisterService
			.getAll({
				IsPoliticalParty: APP_TYPE == "PoliticalParty",
				CheckProcessingStatus: false
			})
			.then((res) => {
				setOnOpenLoading(false);
				var provisional = res.filter((e) => e.voterRegisterTypeID == 1);
				var final = res.filter((e) => e.voterRegisterTypeID == 2);

				setProvisionalEventsRegister(provisional);
				setFinalEventsRegister(final);

				var filtered = defaultOptions;
				if (provisional.length > 0) {
					filtered = filtered.filter((e) => e.reportID != 20);
				}

				if (final.length > 0) {
					filtered = filtered.filter((e) => e.reportID != 11);
				}

				setOptions(filtered);
			})
			.catch((r) => { });
	}
	function filterForPortal() {
		if (isPortal == true) {
			return options?.length ? (options ?? [])?.filter((e) => e.portal === true) : [];
		}
		return options;
	}
	function formatDateToYYYYMMDD(timestamp) {
		// Create a Date object from the timestamp
		const date = new Date(timestamp);

		// Get the year, month, and day
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are zero-based
		const day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits

		// Return the formatted date in "YYYY-MM-DD" format
		return `${year}-${month}-${day}`;
	}

	var [_eligibilityStatus, _] = useState([
		{ name: "Eligible", id: "Y" },
		{ name: "Ineligible", id: "N" }
	]);
	var [MOHARequesStatuses, _] = useState([
		{ name: "All", id: null },
		{ name: "Successful", id: true },
		{ name: "Failed", id: false }
	]);
	var [MOHAStatuses, _] = useState([
		{ name: "All", id: null },
		{ name: "Active", id: 1 },
		{ name: "Deceased", id: 2 },
		{ name: "Person Not Found", id: 3 }
	]);
	var [MOHAVerificationStatuses, _] = useState([
		{ name: "All", id: null },
		{ name: "Passed", id: 1 },
		{ name: "Failed", id: 0 }
	]);

	var [ElectionStructureType, _] = useState([
		{ name: "National Assembly", id: 1, value: true },
		{ name: "Local Goverment", id: 2, value: false}
	]);

	var [lookUpData, setLookUpData] = useState({});

	// {
	// 	"eventTypeID": 1,
	// 	"eventGroupID": 1,
	// 	"startDate": "2022-01-03",
	// 	"endDate": "2025-02-08",
	// 	"district": 1,
	// 	"village": null,
	// 	"constituency": null,
	// 	"polling": null,
	// 	"centre": null,
	// 	"applicationTypeID": 1,
	// 	"applicationStatusID": 4,
	// 	"EligibilityStatus": null,
	// 	"reportID": 1
	// }

	var [deviceTansmissionFilterOptions, setDeviceTansmissionFilterOptions] = useState([
		{
			id: "A",
			name: "All"
		},
		{
			id: "Y",
			name: "Transmitted"
		},
		{
			id: "N",
			name: "Not transmitted"
		}
	]);
	var [reportInfo, setReportInfo] = useState({
		eventTypeID: ElectionStructureType[0].id,
		eventGroupID: 1,
		delimitationgroup: 1,
		startDate: new Date(),
		endDate: new Date(),
		selectedReport: null,
		delimitationID: null,
		delimitationLevelID: null,
		applicationTypeID: null,
		applicationStatusID: null,
		EligibilityStatus: null,
		IncludeSupplimentaryReport: false,
		EventID: null,
		IsInternal: APP_TYPE != "PoliticalParty",
		showVillage: true,
		voterRegisterID: null,
		isNationalDelimitation: null,
		userID: null,
		ProductionOnlyDevice: null,
		Transmitted: null,
		ApplicationsCount: null,
		ApplicationChannelID: null,
		AgeGroupReportTypeID: null,
		MohaAttributeID: null,
		RequestCategoryID: null,
		RequestStatus: null,
		IDNumber: null,
		MohaStatus: null,
		MohaVerificationStatus: null,
		IncludeSDEOdevices: false,
		IsOfficeDemarcation: false,
		SortOptions: []
	});

	function errorHandler() { }

	function emptyStringToNull(S) {
		// Check if the string is empty, return null
		if (S === "") {
			return null;
		}

		// Try to parse the string as an integer
		const parsedInt = parseInt(S, 10);

		// If it's a valid integer (i.e., not NaN), return the parsed integer
		if (!isNaN(parsedInt)) {
			return parsedInt;
		}

		// If not a valid integer, return null
		return null;
	}

	return (
		<>
		
			<ScreenLoader visible={onOpenLoading} />
			<div className="grid">
				<div className="col-12">
					<label>Report <span className="required-input">*</span></label>
					<Dropdown
						filter
						style={{ width: "100%" }}
						optionLabel="name"
						value={reportInfo.selectedReport}
						onChange={(e) => {
							setSelectedRegisterValue(null);
							setRefresh(!refresh)
							setReportInfo({
								...reportInfo,
								eventTypeID: null,
								selectedReport: e.value,
								EligibilityStatus: null,
								applicationStatusID: null,
								applicationTypeID: null,
								startDate: new Date(),
								endDate: new Date(),
								EventID: null,
								showVillage: e.value.showVillage,
								userID: null,
								ProductionOnlyDevice: null,
								Transmitted: null,
								ApplicationsCount: null,
								ApplicationChannelID: null,
								AgeGroupReportTypeID: null,
								MohaAttributeID: null,
								RequestCategoryID: null,
								RequestStatus: null,
								IDNumber: "",
								MohaStatus: null,
								MohaVerificationStatus: null,
								delimitationID: null,
								delimitationLevelID: null,
								SortOptions: []
							})
						}
						}
						options={filterForPortal()}
						placeholder="Select a Report"
					/>
				</div>

				{reportInfo?.selectedReport?.Event && (
					<div className="col-3">
						<label>Event {reportInfo?.selectedReport?.eventRequired && <span className="required-input">*</span>}</label>
						<Dropdown
							filter
							style={{ width: "100%" }}
							optionLabel="name"
							optionValue="eventID"
							value={reportInfo.EventID}
							onChange={(e) => {
								setRefresh(!refresh)
								const event = events?.find((x) => x?.eventID == e?.value);
								setIsNationalDemarcation(event ? event.isNationalDelimitation : true);
								setReportInfo({
									...reportInfo,
									EventID: e.value,
									EventTypeID: (event ? event.isNationalDelimitation : true) ? 1 : 0
								})
								
							}
							}
							options={events}
							placeholder="Select Event"
						/>
					</div>
				)}
				
				{reportInfo?.selectedReport?.ElectionStructureSelect && (
					<div className="col-3">
						<label>Election Structure</label>
						<Dropdown
							filter
							style={{ width: "100%" }}
							optionLabel="name"
							optionValue="value"
							value={reportInfo.isNationalDelimitation}
							onChange={(e) => {
								setReportInfo({
									...reportInfo,
									isNationalDelimitation: e.value
								})
							}
							}
							options={ElectionStructureType}
							placeholder="Select Event Type"
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.voterRegister && (
					<div className="col-3">
						<label>Register</label>
						<Dropdown
							filter
							style={{ width: "100%" }}
							optionLabel="name"
							value={selectedRegisterValue}
							onChange={(e) => {
								setRefresh(!refresh)
								setReportInfo({
									...reportInfo,
									EventID: e.value.eventID,
									EventTypeID: e.value.isNationalDelimitation ? 1 : 0,
									voterRegisterID: e.value.voterRegisterID
								});
								setSelectedRegisterValue(e.value);
							}}
							options={provisionalEventsRegister.filter((x) => x.registerTypeID == 1)}
							placeholder="Select register"
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.finalVoterRegister && (
					<div className="col-3">
						<label>Register</label>
						<Dropdown
							filter
							style={{ width: "100%" }}
							optionLabel="name"
							value={selectedRegisterValue}
							onChange={(e) => {
								setReportInfo({
									...reportInfo,
									EventID: e.value.eventID,
									EventTypeID: e.value.isNationalDelimitation ? 1 : 0,
									voterRegisterID: e.value.voterRegisterID
								});
								setSelectedRegisterValue(e.value);
							}}
							options={finalEventsRegister.filter((x) => x.registerTypeID == 1)}
							placeholder="Select register"
						/>
					</div>
				)}

				{reportInfo?.selectedReport?.IncludeSupplimentaryReport && (
					<div className="col-3">
						<label>Include Supplementary List</label>
						<Checkbox
							style={{ width: "100%" }}
							checked={reportInfo.IncludeSupplimentaryReport}
							onChange={(e) => {
								setReportInfo({ ...reportInfo, IncludeSupplimentaryReport: e.checked });
							}}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.start_date && (
					<div className="col-3">
						<label>Start Date</label>
						<Calendar
							style={{ width: "100%" }}
							dateFormat="dd/mm/yy"
							value={reportInfo.startDate}
							onChange={(e) => {
								setReportInfo({ ...reportInfo, startDate: e.value });
							}}
						/>
					</div>
				)}

				{reportInfo?.selectedReport?.end_date && (
					<div className="col-3">
						<label>End Date</label>
						<Calendar
							style={{ width: "100%" }}
							dateFormat="dd/mm/yy"
							value={reportInfo.endDate}
							onChange={(e) => setReportInfo({ ...reportInfo, endDate: e.value })}
						/>
					</div>
				)}

				{reportInfo?.selectedReport?.application_channel && (
					<div className="col-3">
						<label>Application Channel </label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.ApplicationChannelID}
							options={[{ name: "All", id: null }, ...(lookUpData?.applicationChannels || [])]}
							onChange={(e) => setReportInfo({ ...reportInfo, ApplicationChannelID: e.value })}
							optionLabel="name"
							optionValue="id"
							placeholder="Select Application Type"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}

				{reportInfo?.selectedReport?.Include_SDEO_devices && (
					<div className="col-3">
						<label>Include SDEO devices</label>
						<Checkbox
							style={{ width: "100%" }}
							checked={reportInfo.IncludeSDEOdevices}
							onChange={(e) => {
								setReportInfo({ ...reportInfo, IncludeSDEOdevices: e.checked });
							}}
						/>
					</div>
				)}

				{reportInfo?.selectedReport?.Is_Office_Demarcation && (
					<div className="col-3">
						<label>Is Office Demarcation</label>
						<Checkbox
							style={{ width: "100%" }}
							checked={reportInfo.IsOfficeDemarcation}
							onChange={(e) => {
								setReportInfo({ ...reportInfo, IsOfficeDemarcation: e.checked });
							}}
						/>
					</div>
				)}

				{reportInfo?.selectedReport?.application_type && (
					<div className="col-3">
						<label>Application Type </label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.applicationTypeID}
							options={[{ name: "All", id: null }, ...(lookUpData?.applicationTypes || [])]}
							onChange={(e) => setReportInfo({ ...reportInfo, applicationTypeID: e.value })}
							optionLabel="name"
							optionValue="id"
							placeholder="Select Application Type"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.application_status && (
					<div className="col-3">
						<label>Application Status</label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.applicationStatusID}
							options={[{ name: "All", id: null }, ...(lookUpData?.applicationStatuses || [])]}
							// onChange={(e) => DistrictHandler(e.value)}
							optionLabel="name"
							optionValue="id"
							onChange={(e) => setReportInfo({ ...reportInfo, applicationStatusID: e.value })}
							placeholder="Select Application Status"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}

				{reportInfo?.selectedReport?.user && (
					<div className="col-3">
						<label>User</label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.userID}
							options={lookUpData?.users || []}
							optionLabel="displayName"
							optionValue="userID"
							onChange={(e) => setReportInfo({ ...reportInfo, userID: e.value })}
							placeholder="Select User"
						/>
					</div>
				)}

				{reportInfo.selectedReport?.elibility_status && (
					<>
						<div className="col-3">
							<label>Eligibility Status</label>
							<Dropdown
								style={{ width: "100%" }}
								filter
								value={reportInfo.EligibilityStatus}
								options={_eligibilityStatus}
								onChange={(e) => setReportInfo({ ...reportInfo, EligibilityStatus: e.value })}
								optionLabel="name"
								optionValue="id"
								placeholder="Select Eligibility"
							/>
						</div>
					</>
				)}
				{/* {reportInfo?.selectedReport?.ageGroupReportType && (
					<div className="col-3">
						<label>Age Group Type</label>
						<Dropdown
							value={reportInfo.AgeGroupReportTypeID}
							optionLabel="name"
							optionValue="id"
							onChange={(e) => setReportInfo({ ...reportInfo, AgeGroupReportTypeID: e.value })}
							style={{ width: "100%" }}
							options={ageGroupTypes|| []}
							placeholder="Select Age Group Type"
						/>
					</div>
				)} */}
				{reportInfo?.selectedReport?.production_only_device && (
					<div className="col-3">
						<label>Device Name</label>
						<InputText
							style={{ width: "100%" }}
							type="text"
							placeholder="Device name"
							value={reportInfo.ProductionOnlyDevice}
							onInput={(e) => setReportInfo({ ...reportInfo, ProductionOnlyDevice: e.target.value })}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.device_transmitted && (
					<div className="col-3">
						<label>Transmission Status</label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.Transmitted}
							options={deviceTansmissionFilterOptions || []}
							optionLabel="name"
							optionValue="id"
							onChange={(e) => setReportInfo({ ...reportInfo, Transmitted: e.value })}
							placeholder="Select Filter"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.device_applications_count && (
					<div className="col-3">
						<label>Applications Transmitted</label>
						<InputText
							style={{ width: "100%" }}
							type="number"
							placeholder="Number of applications"
							value={reportInfo.ApplicationsCount}
							onInput={(e) =>
								setReportInfo({ ...reportInfo, ApplicationsCount: e.target.value === "" ? null : Number(e.target.value) })
							}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.FinalBallotEvent && (
					<div className="col-3">
						<label>Event Register</label>
						<Dropdown
							filter
							style={{ width: "100%" }}
							optionLabel="name"
							value={finalEventsRegister.find(
								(event) => event.eventID !== null && reportInfo.EventID !== null && event.eventID === reportInfo.EventID
							)}
							onChange={(e) => {
								setReportInfo({
									...reportInfo,
									EventID: e.value.eventID,
									EventTypeID: e.value.isNationalDelimitation ? 1 : 0
								});
							}}
							options={finalEventsRegister.filter((r) => r.registerTypeID == 1)}
							placeholder="Select Event Register"
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.IDNumber && (
					<div className="col-3">
						<label>ID Number</label>
						<InputText
							style={{ width: "100%" }}
							type="text"
							placeholder="ID Number"
							value={reportInfo.IDNumber}
							onInput={(e) => setReportInfo({ ...reportInfo, IDNumber: e.target.value })}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.mohaRequestCategory && (
					<div className="col-3">
						<label>MOHA Request Category</label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.RequestCategoryID}
							options={[{ name: "All", id: null }, ...(lookUpData?.mohaRequestCategories || [])]}
							onChange={(e) => setReportInfo({ ...reportInfo, RequestCategoryID: e.value })}
							optionLabel="name"
							optionValue="id"
							placeholder="Select MOHA Request Category"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.mohaRequestAttribute && (
					<div className="col-3">
						<label>MOHA Attributes</label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.MohaAttributeID}
							options={[{ name: "All", id: null }, ...(lookUpData?.mohaAttributes || [])]}
							onChange={(e) => setReportInfo({ ...reportInfo, MohaAttributeID: e.value })}
							optionLabel="name"
							optionValue="id"
							placeholder="Select MOHA Attribute"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.mohaRequestStatus && (
					<div className="col-3">
						<label>MOHA Request Status</label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.RequestStatus}
							options={MOHARequesStatuses || []}
							onChange={(e) => setReportInfo({ ...reportInfo, RequestStatus: e.value })}
							optionLabel="name"
							optionValue="id"
							placeholder="Select MOHA Request Status"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.mohaStatus && (
					<div className="col-3">
						<label>MOHA Status</label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.MohaStatus}
							options={MOHAStatuses || []}
							onChange={(e) => setReportInfo({ ...reportInfo, MohaStatus: e.value })}
							optionLabel="name"
							optionValue="id"
							placeholder="Select MOHA Status"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}
				{reportInfo?.selectedReport?.mohaVerificationStatus && (
					<div className="col-3">
						<label>MOHA Verification Status</label>
						<Dropdown
							style={{ width: "100%" }}
							filter
							value={reportInfo.MohaVerificationStatus}
							options={MOHAVerificationStatuses || []}
							onChange={(e) => setReportInfo({ ...reportInfo, MohaVerificationStatus: e.value })}
							optionLabel="name"
							optionValue="id"
							placeholder="Select MOHA Verification Status"
							valueTemplate={(option) => option?.name || "All"}
							itemTemplate={(option) => option?.name || "All"}
						/>
					</div>
				)}
				
				

				{reportInfo.selectedReport?.showSortFilter && (<div className="col-12">
					<ReportSortOrder  key={JSON.stringify(reportInfo.selectedReport)} InludeVillageOnSortConfig = {InludeVillageOnSortConfig} onChange={(levels)=>{
						setReportInfo({ ...reportInfo, SortOptions: levels })
					}} />
				</div>)}

				<div className="col-12">
					<hr />
				</div>
				{reportInfo.selectedReport?.delimitation && (
					<>
						<div className="col-12">
							{!isPortal && !reportInfo.selectedReport?.localDelimitationNational && (
								<UserDelimitation
									key={reportInfo?.selectedReport?.reportID}
									showVillage={reportInfo.showVillage}
									isReport={true}
									showFilter={reportInfo.selectedReport?.isNationalElectionReport}
									isNationalElectionReport={reportInfo.selectedReport?.isNationalElectionReport}
									onDelimitationChanged={(e) => {
										reportInfo.delimitationID = emptyStringToNull(e.delimitationID);
										reportInfo.delimitationLevelID = emptyStringToNull(e.delimitationLevelID);
										setReportInfo({ ...reportInfo });
									}}
								/>
							)}

							{(isPortal || reportInfo.selectedReport?.localDelimitationNational) && (
								<LocalDelimitationNational
									key={refresh}
									politicalDelimitation={{ ...portalUserDemarcation() }}
									HideApplyLocalDelimitationNational={reportInfo.selectedReport?.HideApplyLocalDelimitationNational}
									showFilter={reportInfo.selectedReport?.showFilter}
									grid="3"
									isNational={
										[null, "", undefined].includes(selectedRegisterValue?.isNationalDelimitation)
											? isNationalDemarcation
											: selectedRegisterValue?.isNationalDelimitation
									}
									isReport={true}
									onChange={(delimitationID, delimitationLevelID, isLastLevel) => {
										reportInfo.delimitationID = emptyStringToNull(delimitationID);
										reportInfo.delimitationLevelID = emptyStringToNull(delimitationLevelID);
										setReportInfo({ ...reportInfo });
									}}
									onFilter={(e) => {
										reportInfo.delimitationID = emptyStringToNull(e.delimitationID);
										reportInfo.delimitationLevelID = emptyStringToNull(e.delimitationLevelID);
										setReportInfo({ ...reportInfo });
									}}
									onClearFilter={(e) => {
										reportInfo.delimitationID = null;
										reportInfo.delimitationLevelID = null;
										setReportInfo({ ...reportInfo });
									}}
								/>
							)}
						</div>
						<div className="col-12">
							<hr />
						</div>
					</>
				)}

				<div className="col-12">
					<Button
						label= {GenerateReportBtnTittle}
						className="p-button-success"
						loading={loading}
						disabled={DisableFetchReportBtn(reportInfo)}
						onClick={() => {
							var reportCopy = { ...reportInfo };
							reportCopy.reportID = reportCopy.selectedReport.reportID;
							reportCopy.endDate = formatDateToYYYYMMDD(reportInfo.endDate);
							reportCopy.startDate = formatDateToYYYYMMDD(reportInfo.startDate);
							delete reportCopy?.selectedReport;
							if (reportCopy.reportID == 24) {
								reportCopy.voterRegisterID = liveProvisionalEventsRegister?.voterRegisterID;
								reportCopy.isNationalDelimitation = liveProvisionalEventsRegister?.isNationalDelimitation;
							} else if (reportCopy.reportID == 25) {
								reportCopy.voterRegisterID = liveFinalEventsRegister?.voterRegisterID;
								reportCopy.isNationalDelimitation = liveFinalEventsRegister?.isNationalDelimitation;
							}
							onSubmit(reportCopy, reportInfo.selectedReport.name);
						}}
					/>
					{ (reportInfo?.selectedReport?.isRegistrationCentreOnlyReport && reportInfo?.delimitationLevelID !== DermacationLevels?.Level4) && (
						<small className="p-error" style={{ display: "block", marginTop: "0.5rem" }}>
							{GenerateReportBtnTittle} button is only available on level 4[Voting Centre/Polling Centre]
						</small>
					)}
				</div>
			</div>
		</>
	);
}
